var $ = require('../internals/export');

var scale = require('../internals/math-scale');

var fround = require('../internals/math-fround'); // `Math.fscale` method
// https://rwaldron.github.io/proposal-math-extensions/


$({
  target: 'Math',
  stat: true
}, {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});